import { Button, Text } from 'styles/AppStyles';
import { Container } from './Styles';
import { currentGameConfig } from 'utils/handleCurrentContentConfig';

const UserNotFound = () => {
  const { redirector } = currentGameConfig;
  return (
    <Container>
      <Text>We couldn't find your user.</Text>
      <Text $weight={600}> Please log in to the game with your Facebook account.</Text>
      <Text>Then come back here and login to the store.</Text>
      <Button $isModal onClick={() => window.open(redirector)}>
        Open App
      </Button>
    </Container>
  );
};

export default UserNotFound;
